import { Flex } from '@aloft/toolkit-sui';
import { PDFViewer } from '@react-pdf/renderer';

import { isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';

import { LoadingScreen } from '../../../components/LoadingScreen/LoadingScreen.tsx';
import { usePdfReportData } from '../../appraisalReport/index.ts';
import { Tkv2PDFModule } from '../../tkv2PDF/Tkv2PDFModule.tsx';
import { Tkv2PDF, Tkv2PDFChartImages } from '../../tkv2PDF/types.ts';
import { generateTkv2PDFChartImages } from '../../tkv2PDF/utils/generateTkv2PDFChartImages.ts';

export const PdfSheet = () => {
  const data = usePdfReportData();

  const [isLoading, setIsLoading] = useState(true);
  const [tkv2ChartImages, setTkv2ChartImages] = useState<Tkv2PDFChartImages>();

  const prevDataRef = useRef<Tkv2PDF>(data);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    if (isEqual(prevDataRef.current, data)) return () => clearTimeout(timer);

    prevDataRef.current = data;
    setIsLoading(true);

    const { chartParams } = data;
    if (chartParams) {
      generateTkv2PDFChartImages(chartParams).then(setTkv2ChartImages).catch(console.error);
    }

    return () => clearTimeout(timer);
  }, [data]);

  if (isLoading || !tkv2ChartImages) {
    return <LoadingScreen overrideText="Preparing your report preview..." />;
  }

  return (
    <Flex width="100%" height="100%">
      <PDFViewer showToolbar={false} style={{ width: '100vw', height: '100%' }}>
        <Tkv2PDFModule {...data} tkv2ChartImages={tkv2ChartImages} signatureImages={{}} />
      </PDFViewer>
    </Flex>
  );
};
